import api from "../..";
import { uploadFile } from "../../file/uploadFile";
import type { SignRequestBody } from "../../file/types";
import type { PostStoryBody, PostStoryParams } from "./types";

export const postStory = async ({ storyFile, coverFile, description, coverText, buttonText,  related_content }: PostStoryParams): Promise<boolean> => {

  const storySignBody: SignRequestBody = {
    item_type: "course",
    item_id: Date.now(),
    object_name: storyFile.name,
    object_type: storyFile.type.startsWith("video") ? "video" : "image",
    object_size: storyFile.size,
  };

  const storyKey = await uploadFile({
    file: storyFile,
    signBody: storySignBody,
  });

  const coverSignBody: SignRequestBody = {
    item_type: "course",
    item_id: Date.now(),
    object_name: coverFile.name,
    object_type: "image",
    object_size: coverFile.size,
  };

  const coverKey = await uploadFile({
    file: coverFile,
    signBody: coverSignBody,
  });

  const body: PostStoryBody = {
    title: coverText,
    label: buttonText,
    description,
    content: storyKey,
    cover_image: coverKey,
    related_content,
  };

  return await api.post("/admin/story/", body)
  .then(() => true)
  .catch(() => false);
};